module.exports = __webpack_public_path__ + "img/banner-bottom.ccae1137.jpg";